import fillProductKey from './middlewares/fillProductKey'
module.exports = {
  model: 'products',
  middlewares: [fillProductKey],
}



// WEBPACK FOOTER //
// ./src/views/products.js